import React from 'react';

import { Currency } from 'components/common/DataFormat';
import { dataCell } from './reportTableCells';
import { trailingSalesCells, SalesReportMetrics } from './salesReportTableLayout';
import ProductHashLink from '../ProductSalesReport/hashLink';
import ServiceHashLink from '../ServiceSalesReport/hashLink';

type CellContent = string | number | JSX.Element;

export type SalesReportRowLinks = {
  venueId: string;
  fromDate: any;
  toDate: any;
  employeeFilter: number;
  selectedChannel: string;
  /** Defaults to true. Channel report sets false except for Connect. */
  includeProductLink?: boolean;
  onServiceLinkClick: (...args: any[]) => any;
  onProductLinkClick: (...args: any[]) => any;
};

export type SalesReportDataCellTestIds = {
  servicesQty: string;
  servicesGross: string;
  productsQty: string;
  productsGross: string;
  voucherQuantity: string;
  voucherGross: string;
  prepaid: string;
  total: string;
};

export const buildSalesReportDataCells = (
  row: SalesReportMetrics,
  testIds: SalesReportDataCellTestIds,
  links?: SalesReportRowLinks,
) => {
  const withServiceLink = (content: CellContent): CellContent =>
    links ? (
      <ServiceHashLink
        venueId={links.venueId}
        fromDate={links.fromDate}
        toDate={links.toDate}
        employeeFilter={links.employeeFilter}
        selectedChannel={links.selectedChannel}
        onClick={links.onServiceLinkClick}
      >
        {content}
      </ServiceHashLink>
    ) : (
      content
    );

  const withProductLink = (content: CellContent): CellContent =>
    links && (links.includeProductLink ?? true) ? (
      <ProductHashLink
        venueId={links.venueId}
        fromDate={links.fromDate}
        toDate={links.toDate}
        employeeFilter={links.employeeFilter}
        onClick={links.onProductLinkClick}
      >
        {content}
      </ProductHashLink>
    ) : (
      content
    );

  return [
    dataCell(withServiceLink(row.numberOfServices ?? 0), {
      dataTestId: testIds.servicesQty,
    }),
    dataCell(withServiceLink(<Currency amount={row.serviceGrossTotal} />), {
      dataTestId: testIds.servicesGross,
    }),
    dataCell(withProductLink(row.numberOfProducts ?? 0), {
      dataTestId: testIds.productsQty,
    }),
    dataCell(withProductLink(<Currency amount={row.productGrossTotal} />), {
      dataTestId: testIds.productsGross,
    }),
    ...trailingSalesCells(row, {
      voucherQuantity: testIds.voucherQuantity,
      voucherGross: testIds.voucherGross,
      prepaid: testIds.prepaid,
      total: testIds.total,
    }),
  ];
};
